import moment from 'moment';

const parseFormatToDate = dateFormat => {
    const parsedDateFormat = dateFormat.toString().replace(/-/g, '');

    var date = moment({
        year: parsedDateFormat.toString().substring(0, 4),
        month: parsedDateFormat.toString().substring(4, 6) - 1,
        date: parsedDateFormat.toString().substring(6, 8),
    });
    return date;
};

const parseDateToFormat = date => {
    date = moment.isMoment(date) ? date : moment(date);
    return date.format('YYYY-MM-DD');
};

const getToday = () => {
    return moment().startOf('day');
};

const getMonday = date => (!date ? getToday().weekday(1) : date.weekday(1));

const getWeeklyDateRange = date => {
    const monday = getMonday(date);
    let startDate = moment(monday);
    let endDate = moment(monday);

    startDate = startDate.subtract(1, 'days');
    endDate = endDate.add(5, 'days');
    return {
        startDate,
        endDate,
    };
};

const getArrayByDateRange = function(startDate, endDate) {
    for (var arr = [], d = moment(startDate); d <= endDate; d.add(1, 'days')) {
        arr.push(moment(d));
    }
    return arr;
};

const getDetailTextByDate = date => {
    var day = moment(date);

    return {
        dayFullString: day.format('dddd'),
        monthFullString: day.format('MMMM'),
        dayShortNumber: day.format('D'),
    };
};

const getEndOfDay = date => {
    return moment(date).endOf('day');
};

const getDayOFWeek = date => parseInt(moment(date).format('d'));

export default {
    getWeeklyDateRange,
    getArrayByDateRange,
    parseFormatToDate,
    parseDateToFormat,
    getToday,
    getMonday,
    getDetailTextByDate,
    getDayOFWeek,
    getEndOfDay,
};
